export const gallery = [
  {
    image: "https://images.unsplash.com/photo-1515003197210-e0cd71810b5f?auto=format&fit=crop&w=1600&q=85",
    label: "The Table",
    className: "gallery-tall"
  },
  {
    image: "https://images.unsplash.com/photo-1572116469696-31de0f17cc34?auto=format&fit=crop&w=1400&q=85",
    label: "After Dark"
  },
  {
    image: "https://images.unsplash.com/photo-1514933651103-005eec06c04b?auto=format&fit=crop&w=1400&q=85",
    label: "The Room"
  },
  {
    image: "https://images.unsplash.com/photo-1552566626-52f8b828add9?auto=format&fit=crop&w=1400&q=85",
    label: "The Feast"
  }
];

export const dishes = [
  {
    name: "Jalsa Signature",
    desc: "A theatrical first pour designed for long evenings.",
    price: "₹495",
    image: "https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?auto=format&fit=crop&w=1000&q=85"
  },
  {
    name: "Smoked Pepper",
    desc: "Charred notes, warm spice and a slow finish.",
    price: "₹545",
    image: "https://images.unsplash.com/photo-1544145945-f90425340c7e?auto=format&fit=crop&w=1000&q=85"
  },
  {
    name: "Jalsa Platter",
    desc: "A table-sized celebration for the whole crew.",
    price: "₹895",
    image: "https://images.unsplash.com/photo-1547592180-85f173990554?auto=format&fit=crop&w=1000&q=85"
  }
];

export const events = [
  { date: "FRI", number: "12", title: "Golden Hour", copy: "Cocktails, vinyl & slow-burning grooves." },
  { date: "SAT", number: "13", title: "Jalsa Nights", copy: "Live energy, signature pours & late dinner." },
  { date: "SUN", number: "14", title: "Sunday Social", copy: "A long lunch that turns into an easy evening." }
];
